import isEmpty from 'lodash/isEmpty'

/**
 * Convert an object to a query string
 * @param {Object} object - The object to convert
 * @returns `string`
 */
export function objectToUrl(object = {}) {
  if (isEmpty(object)) {
    return ''
  }

  // Convert the object to an array of key=value pairs
  return Object.entries(object)
    .map(([key, val]) => {
      // If the value is a number, a boolean or a string, return it as is (i.e. ?key=123 or ?key=123.45)
      if (
        typeof val === 'number' ||
        typeof val === 'boolean' ||
        typeof val === 'string'
      ) {
        return `${key}=${val}`
      }

      // If the value is undefined, return null
      if (isEmpty(val)) {
        return null
      }

      // If the value is an array, add multiple key[]=val1&key[]=val2
      if (Array.isArray(val)) {
        return val.map(item => `${key}[]=${item}`).join('&')
      }

      // If the value is an object, stringify it (as JSON string, i.e. ?key={"val1":"val2"})
      if (typeof val === 'object') {
        return `${key}=${JSON.stringify(val)}`
      }

      // Otherwise, in case of an unexpected value type, console.log it and return null
      console.log('👀 fetcher/objectToUrl', key, typeof val, val) // eslint-disable-line no-console
      return null
    })
    .filter(Boolean) // Remove all empty values
    .join('&') // Join all the key=value pairs with an ampersand
}
